export default "__VITE_ASSET__BIkHKCXk__"